import { render } from "./ContentInput.vue?vue&type=template&id=349fdda2"
import script from "./ContentInput.vue?vue&type=script&lang=js"
export * from "./ContentInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__